import * as React from 'react';
import { styles } from './styles';
import { DesignBucketShell, DesignBucketShellProps } from '../components/DesignBucketShell';
import { DesignShowcaseSectionConfig } from '../../..';
import { capitalize } from 'utils/strings';
import {
  DesignShowcase_designShowcase_organization_colors_buckets,
  DesignShowcase_designShowcase_organization_colors
} from '@graphql/designShowcaseTypes';
import { BucketGroupOption } from '../components/BucketGroupOption';
import { InlineDialogProps } from '../../InlineDialog';
import { Columns } from '@joykit';
import { SpatialOption } from '@joykit/variables/space';

interface Props extends DesignShowcaseSectionConfig<DesignShowcase_designShowcase_organization_colors_buckets> {
  onOptionSelect: React.MouseEventHandler<HTMLElement>;
  onCloseRequest: InlineDialogProps<null>['onCloseRequest'];
  isMobile?: boolean;
  options: DesignShowcase_designShowcase_organization_colors['buckets'];
}

export class ColorBucket extends React.Component<Props & DesignBucketShellProps> {
  render() {
    const valueString = this.props.values.map(val => capitalize(val.displayString)).join(', ');
    const valueSet = new Set(this.props.values.map(val => val.bucketId));
    return (
      <DesignBucketShell
        isMobile={this.props.isMobile}
        section="colors"
        label="Color"
        open={this.props.open}
        onClose={this.props.onCloseRequest}
        subtitle={valueString}
        onTriggerClick={this.props.onTriggerClick}
        onResetClick={this.props.onResetClick}
      >
        <DesignBucketShell.Content className={styles.container}>
          <Columns
            columnGap={this.props.isMobile ? SpatialOption.xs : SpatialOption.sm}
            multiline={true}
            stackOnMobile={true}
          >
            {this.props.options.map((op, index) => {
              if (op) {
                return (
                  // <div key={op.bucketId} className={styles.colorContainer}>
                  <Columns.Column key={op.bucketId} mobile="one-quarter" tablet="one-quarter">
                    <BucketGroupOption
                      section="colors"
                      value={op.bucketId}
                      onClick={this.props.onOptionSelect}
                      ariaLabel={`Toggle ${op.displayString} color`}
                    >
                      <div
                        className={styles.color(
                          op.displayRGBAColor!.hexString,
                          valueSet.has(op.bucketId),
                          op.bucketId === 'white'
                        )}
                      />
                    </BucketGroupOption>
                    {/* </div> */}
                  </Columns.Column>
                );
              }
              return null;
            })}
          </Columns>
        </DesignBucketShell.Content>
      </DesignBucketShell>
    );
  }
}
